import { render, staticRenderFns } from "./notificationTemplate.vue?vue&type=template&id=1f400bee&"
import script from "./notificationTemplate.vue?vue&type=script&lang=js&"
export * from "./notificationTemplate.vue?vue&type=script&lang=js&"
import style0 from "./notificationTemplate.vue?vue&type=style&index=0&id=1f400bee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports